import type { TrackingFeature } from '@shared/types/tracking.ts';
import type { BlackFridaySliderItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import { isBlackFridaySliderItem } from '@tilelist/domain/composition/TileListitem.ts';
import { BLACK_FRIDAY_SLIDER_POSITION } from '@tilelist/domain/feature-visibility/BlackFridaySlider.ts';

export const BLACK_FRIDAY_SLIDER_FEATURE_ID = 'find_slider_1';
const SLIDER_TYPE = 'rating_black_friday';
const RATING_SLIDER_LIST_FEATURE = 'ratingSlider';
const TILELIST_FEATURE_ID = 'find_tilelist_1';

export function sliderTileFeatureId(position: number): string {
    return `find_slider_tile_${position}`;
}

export function blackFridaySliderLabels() {
    return { san_ListSliderType: [SLIDER_TYPE], 'wk.san_ListFeatures': [RATING_SLIDER_LIST_FEATURE] };
}

/*                                                                                            */
export function listFeaturesLabels(items: TileListItem[] = []) {
    const hasReadySlider = items.some((item) => isBlackFridaySliderItem(item) && item.state === 'ready');

    return { 'wk.san_ListFeatures': [hasReadySlider ? RATING_SLIDER_LIST_FEATURE : 'none'] };
}

/**
 *
 *
 */
export function blackFridaySliderFeatures(slider: BlackFridaySliderItem): TrackingFeature[] {
    if (slider.state !== 'ready') return [];

    return [
        {
            id: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            name: 'RatingSlider',
            position: BLACK_FRIDAY_SLIDER_POSITION,
            status: 'loaded',
            parentId: TILELIST_FEATURE_ID,
        },
        ...slider.items.map((item): TrackingFeature => ({
            id: sliderTileFeatureId(item.localListPosition),
            name: 'RatingSlider-Tile',
            position: item.localListPosition,
            variationId: item.product.bestVariationId,
            status: 'loaded',
            parentId: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            labels: { san_ProductType: [item.product.productType] },
        })),
    ];
}
